import { AngleDown as AngleDownIcon } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import { WorkspaceAvatar } from '../../../WorkspaceAvatar'
import css from './styles.module.css'

interface Props {
  open: boolean
  avatar: string | null
  title?: string
  onSetRef: (
    ref:
      | ((prevState: HTMLElement | null) => HTMLElement | null)
      | HTMLElement
      | null
  ) => void
  onClick: () => void
}

export const DropdownButton: React.FC<Props> = ({
  open,
  avatar,
  title,
  onSetRef,
  onClick,
}) => {
  return (
    <button
      ref={onSetRef}
      className={clsJoin(css.button, open && css.open)}
      onClick={onClick}
    >
      <div className={css.avatar}>
        <WorkspaceAvatar url={avatar} />
      </div>
      <span className={css.title}>{title}</span>
      <div className={css.icon}>
        <AngleDownIcon />
      </div>
    </button>
  )
}
